import { graphql, useStaticQuery } from "gatsby";

/**
 * Retrieves job list data from a GraphQL query.
 * with only the fields necessary for to display in the JobCard component.
 *
 * @return {Object} The job list data.
 */
const JobListData = () => {
    const jobData = useStaticQuery(
        graphql`
            query JobListData {
                jobs: allJob(
                    sort: [{ sentDate: DESC }, { lastUpdatedDate: DESC }]
                    filter: { jobState: { eq: "Open" }, internalOnly: { eq: false } }
                ) {
                    totalCount
                    edges {
                        node {
                            id: eId
                            category
                            title
                            briefDescription
                            jobLocations {
                                eId
                                name
                            }
                            locationCountry
                        }
                    }
                }
            }
        `
    );

    return jobData;
};

export default JobListData;
